import { FC } from 'react';

import { TMuiInputSize } from '../types';

export const MuiDefaultInputFallback: FC<{ size: TMuiInputSize }> = ({ size }) => (
    <div style={{ minHeight: size === 'small' ? '40px' : '56px' }} />
);
